export default __webpack_public_path__ + "static/media/ashushi.3e9f1136.svg";